<app-learning-hub-header
  [lang]="lang"
  [options]="options"
  (selectLanguage)="changeLanguage($event)"
></app-learning-hub-header>

<div class="lh-columns">
  <article class="lh-article">
    <app-learning-hub-breadcrumb [items]="breadcrumb" [lang]="lang"></app-learning-hub-breadcrumb>

    <p class="lh-status" *ngIf="loading">{{ 'learningHub.loading' | lhTranslate: lang }}</p>

    <div class="lh-state" *ngIf="!loading && status === 'not-found'">
      <h1 class="lh-state-title">{{ 'learningHub.notFoundTitle' | lhTranslate: lang }}</h1>
      <p>{{ 'learningHub.notFoundDescription' | lhTranslate: lang }}</p>
      <a class="lh-state-link" [routerLink]="['/', modulePath]" [queryParams]="{ lang: lang }">{{
        'learningHub.backToHome' | lhTranslate: lang
      }}</a>
    </div>

    <p class="lh-state" *ngIf="!loading && status === 'error'">{{ 'learningHub.loadError' | lhTranslate: lang }}</p>

    <ng-container *ngIf="!loading && status === 'ready'">
      <header class="lh-article-header">
        <h1 class="lh-article-title">{{ article.title }}</h1>
        <div class="lh-article-meta">
          <span>{{ meta.date | date: 'dd/MM/yyyy' }}</span>
          <span aria-hidden="true">·</span>
          <span>{{ 'learningHub.readingTime' | lhTranslate: meta.lang:{ minutes: meta.readingMinutes } }}</span>
        </div>
      </header>

      <!-- Bound as a string: Angular's DomSanitizer cleans it (no bypassSecurityTrust*). -->
      <div #content class="lh-content" [innerHTML]="article.html" (click)="onContentClick($event)"></div>

      <footer class="lh-article-tags" *ngIf="meta.tags.length">
        <a
          class="lh-chip"
          *ngFor="let tag of meta.tags"
          [routerLink]="['/', modulePath, 'search']"
          [queryParams]="{ lang: meta.lang, tag: tag.slug }"
          >#{{ tag.name }}</a
        >
      </footer>
    </ng-container>
  </article>

  <app-learning-hub-sidebar
    class="lh-aside"
    *ngIf="!loading && tree"
    [lang]="lang"
    [tree]="tree"
    [articles]="index"
    [activeKey]="category?.key || null"
    [currentArticleId]="meta ? meta.id : null"
  ></app-learning-hub-sidebar>
</div>
